export default __webpack_public_path__ + "static/Teodor-Light-3f3d0c79de2bddab812035ffd34def5e.woff2";